import { createContext } from "react";
import { ContextDefaultValue, defaultState } from "./types";

export const TranslationContext = createContext<ContextDefaultValue>([defaultState, () => {}]);
